export default __webpack_public_path__ + "static/media/closeSidebar.5cdabb36.svg";